export default __webpack_public_path__ + "static/bg-395d7e63986d24607a66541e240f6058.png";